import { ControllerPage } from "../pages/ControllerPage";
import { ControllerWindow } from "../windows/ControllerWindow";
import { GetBy } from "./Element";

export const KEYS = {
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  ESC: 27,
  HOME: 36,
  END: 35,
  AVPAG: 34,
  REPAG: 33,

  // WASD
  W: 87,
  A: 65,
  S: 83,
  D: 68,

  // Numbers
  NUM_0: 48,
  NUM_1: 49,
  NUM_2: 50,
  NUM_3: 51,
  NUM_4: 52,
  NUM_5: 53,
  NUM_6: 54,
  NUM_7: 55,
  NUM_8: 56,
  NUM_9: 57
};

export default class Keyboard {
  static isEnabled = false;
  static calls = {};

  static enable() {
    if (!this.isEnabled) {
      this.isEnabled = true;
      document.addEventListener('keydown', (e) => this._check(e));
    }
  };

  static disable() {
    if (this.isEnabled) {
      this.isEnabled = false;
      document.removeEventListener('keydown', (e) => this._check(e));
    }
  };

  static add(key, id, call) {
    if (!this.calls[key]) this.calls[key] = [];
    this.calls[key][id] = call;
  };

  static remove(key, id) {
    if (!this.calls[key]) return;
    this.calls[key] = this.calls[key].filter(kid => kid !== id);
  };

  static mountPage(id) {
    const links = GetBy.selector('a[data-keyboard]');

    for (let index = 0; index < links.length; index++) {
      const link = links[index];
      const key = link.dataset.keyboard;
      Keyboard.add(KEYS[key], `${id}-${index}`, () => { ControllerPage.changePage(link.href) });
    }
  }

  static unmountPage(id) {
    const links = GetBy.selector('a[data-keyboard]');

    for (let index = 0; index < links.length; index++) {
      const link = links[index];
      const key = link.dataset.keyboard;
      Keyboard.remove(KEYS[key], `${id}-${index}`);
    }
  }

  static _check(e) {
    Object.keys(this.calls)
      .filter(key => parseInt(key) === e.keyCode)
      .map(key => {
        const k =  this.calls[key];
        Object.keys(k).map(id => { k[id].call(); });
      });
  }
};
